import { ExtendedAccountData } from '@/backend/features/contact-management/entities/extended-account/types';
import { formatDate } from '@juvare/common-web-ui/utils';

export const defaultBadgeSampleAccountData: ExtendedAccountData = {
    consent: false,
    orgRole: {},
    orgStatus: {},
    systemRole: 'user',
    systemStatus: 'active',
    firstName: 'John',
    lastName: 'Doe',
    email: 'john@example.com',
    address: { addressLine1: 'Street 1', addressLine2: 'Street 2', city: 'City 1' },
    dateOfBirth: formatDate(new Date('01/13/1990')),
    heightFeet: 5,
    heightInches: 0,
};
